import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import axios from "axios";
import i18next from "i18next";

// Compact category card — small fixed height so the row takes little vertical space.
function CategoryCard({ item, localhostImg }) {
  return (
    <a href={`/shop?category=${item.id}`} className="group block px-1">
      <div className="relative w-full h-32 sm:h-40 lg:h-44 overflow-hidden rounded-lg bg-gray-100">
        <img
          loading="lazy"
          src={localhostImg + item.categ_imgs[0]}
          alt={item.name[i18next.language]}
          className="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-300 ease-in-out opacity-100 group-hover:opacity-0"
        />
        {item.categ_imgs[1] ? (
          <img
            loading="lazy"
            src={localhostImg + item.categ_imgs[1]}
            alt={item.name[i18next.language]}
            className="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-300 ease-in-out opacity-0 group-hover:opacity-100"
          />
        ) : null}
      </div>
      <p className="mt-2 text-center text-xs sm:text-sm font-medium text-gray-800 truncate">
        {item.name[i18next.language]}
      </p>
    </a>
  );
}

export default function CategoriesCarousel() {
  const { t } = useTranslation();
  const localhost = process.env.REACT_APP_LOCALHOST;
  const localhostImg = process.env.REACT_APP_LOCALHOST_IMG;
  const [allCategories, setAllCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCategories = async () => {
    try {
      const res = await axios.get(localhost + "all-categories");
      setAllCategories(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      // console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cats = allCategories.filter((c) => c.categ_imgs);
  const total = cats.length;

  const Header = () => (
    <div className="mb-4">
      <h2 className="text-2xl font-bold text-gray-900 sm:text-3xl">{t("categories")}</h2>
      <p className="text-base text-gray-600">{t("our-products-categories")}</p>
    </div>
  );

  if (loading) {
    return (
      <div className="max-w-[1600px] mx-auto px-3 sm:px-6 pt-12 sm:pt-16 lg:pt-20">
        <Header />
        <div className="flex items-center justify-center w-full h-48">
          <div className="loading-spinner" />
        </div>
      </div>
    );
  }

  if (total === 0) return null;

  const renderCarousel = (visibleSlides, arrowSize) => (
    <CarouselProvider
      isPlaying
      naturalSlideWidth={100}
      naturalSlideHeight={100}
      isIntrinsicHeight
      totalSlides={total}
      visibleSlides={Math.min(visibleSlides, total)}
      step={1}
      infinite
    >
      <div className="w-full relative flex items-center">
        <ButtonBack aria-label="slide backward" className="absolute z-10 -left-2 top-1/2 -translate-y-1/2 bg-white/90 shadow rounded-full p-1.5 disabled:opacity-40">
          <ChevronLeftIcon className={`${arrowSize} text-gray-800`} />
        </ButtonBack>
        <div className="w-full overflow-hidden px-1">
          <Slider>
            {cats.map((item, index) => (
              <Slide key={index} index={index}>
                <CategoryCard item={item} localhostImg={localhostImg} />
              </Slide>
            ))}
          </Slider>
        </div>
        <ButtonNext aria-label="slide forward" className="absolute z-10 -right-2 top-1/2 -translate-y-1/2 bg-white/90 shadow rounded-full p-1.5 disabled:opacity-40">
          <ChevronRightIcon className={`${arrowSize} text-gray-800`} />
        </ButtonNext>
      </div>
    </CarouselProvider>
  );

  return (
    <div className="max-w-[1600px] mx-auto px-3 sm:px-6 pt-12 sm:pt-16 lg:pt-20">
      <Header />
      <div className="hidden lg:block">{renderCarousel(6, "size-5")}</div>
      <div className="hidden md:block lg:hidden">{renderCarousel(4, "size-5")}</div>
      <div className="block md:hidden">{renderCarousel(3, "size-4")}</div>
    </div>
  );
}
